import { Routes } from '@angular/router';
import { accessGuard } from '@app/shared/access/access.guard';

import { payrollExitGuard } from './payroll-exit.guard';
import { payrollAccess } from './payroll.access';

export const payrollRoutes: Routes = [
  {
    path: 'payroll',
    data: {
      ...payrollAccess.payroll,
    },
    canActivate: [accessGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./overview/payroll-overview-page.component').then((m) => m.PayrollOverviewPageComponent),
      },
      {
        path: 'prepare',
        canDeactivate: [payrollExitGuard],
        loadComponent: () => import('./payroll-page.component').then((m) => m.PayrollPageComponent),
      },
    ],
  },
];
